import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { transformResponseHandler } from 'utils/transformResponseHandler';

export const offersApi = createApi({
    reducerPath: 'offersApi',
    baseQuery: fetchBaseQuery({
        baseUrl: `${process.env.REACT_APP_API_ROUTE}`,
        prepareHeaders: (headers, { getState }) => {
            const token = getState()?.posData?.token;
            if (token) {
                headers.set('Authorization', token);
            }
            return headers;
        },
    }),
    tagTypes: ['Offers'],
    endpoints: (builder) => ({
        getOffers: builder.query({
            query: ({ search, status, type, startDate, endDate, page, perPage } = {}) => {
                const params = {};
                if (search) params.search = search;
                if (status) params.status = status;
                if (type) params.type = type;
                if (startDate) params.startDate = startDate;
                if (endDate) params.endDate = endDate;
                if (page) params.page = page;
                if (perPage) params.perPage = perPage;
                return {
                    url: '/pos/offers',
                    method: 'GET',
                    params,
                };
            },
            providesTags: ['Offers'],
            transformErrorResponse: (error) => transformResponseHandler(error)
        }),
        getOfferById: builder.query({
            query: (id) => ({
                url: `/pos/offers/${id}`,
                method: 'GET',
            }),
            providesTags: (result, error, arg) => [{ type: 'Offers', id: arg }],
            transformErrorResponse: (error) => transformResponseHandler(error)
        }),
        addOffer: builder.mutation({
            query: (body) => ({
                url: '/pos/offers',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['Offers'],
            transformResponse: (resp) => transformResponseHandler(resp),
            transformErrorResponse: (error) => transformResponseHandler(error)
        }),
        updateOffer: builder.mutation({
            query: ({ id, ...body }) => ({
                url: `/pos/offers/${id}`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: ['Offers'],
            transformResponse: (resp) => transformResponseHandler(resp),
            transformErrorResponse: (error) => transformResponseHandler(error)
        }),
        deleteOffer: builder.mutation({
            query: (id) => ({
                url: `/pos/offers/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['Offers'],
            transformResponse: (resp) => transformResponseHandler(resp),
            transformErrorResponse: (error) => transformResponseHandler(error)
        }),
        changeOfferStatus: builder.mutation({
            query: ({ id, status }) => ({
                url: `/pos/offers/change-status/${id}`,
                method: 'PUT',
                body: { status },
            }),
            invalidatesTags: ['Offers'],
            transformResponse: (resp) => transformResponseHandler(resp),
            transformErrorResponse: (error) => transformResponseHandler(error)
        }),
    })
});

export const {
    useGetOffersQuery,
    useGetOfferByIdQuery,
    useAddOfferMutation,
    useUpdateOfferMutation,
    useDeleteOfferMutation,
    useChangeOfferStatusMutation,
} = offersApi;
